var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "#E45C51",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16882_235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58341 11.6249H6.20841V5.12494H4.58341C4.43976 5.12494 4.30198 5.18201 4.2004 5.28359C4.09882 5.38517 4.04175 5.52295 4.04175 5.66661V11.0833C4.04175 11.2269 4.09882 11.3647 4.2004 11.4663C4.30198 11.5679 4.43976 11.6249 4.58341 11.6249ZM7.45046 12.3253L10.9171 15.792C10.9632 15.8382 11.0244 15.8662 11.0895 15.8709C11.1546 15.8756 11.2192 15.8566 11.2714 15.8174L11.7334 15.4708C11.8617 15.3744 11.9587 15.2423 12.012 15.0909C12.0653 14.9396 12.0726 14.7758 12.033 14.6204L11.4084 12.1666H14.8751C15.1624 12.1666 15.4379 12.0525 15.6411 11.8493C15.8443 11.6461 15.9584 11.3706 15.9584 11.0833V9.94361C15.9586 9.80204 15.931 9.66181 15.8772 9.53086L14.2007 5.46023C14.1598 5.36099 14.0904 5.27613 14.0011 5.21644C13.9119 5.15674 13.807 5.12489 13.6997 5.12494H7.83341C7.68976 5.12494 7.55198 5.18201 7.4504 5.28359C7.34882 5.38517 7.29175 5.52295 7.29175 5.66661V11.9424C7.29178 12.086 7.34887 12.2238 7.45046 12.3253Z",
    fill: "#E45C51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16882_235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "matrix(1 0 0 -1 3.5 16.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertHigh);
export default __webpack_public_path__ + "static/media/alert-high.dde914f56f7083017455a9dee2268bd0.svg";
export { ForwardRef as ReactComponent };